import React from 'react';
import ReactDOM from 'react-dom';

import ShareApp from '../app/components/ShareApp.jsx';

const root = document.getElementById('root-share');

if (root) {
  ReactDOM.render((
    <ShareApp />
  ), root);
}
